export const cacheKeys = {
  getCredit: 'getCredit',
  getCredits: 'getCredits',
  editCredit: 'editCredit',
};